<template >
  <div id="invoice-page" :hidden="invoiceValidate">
    <vx-card id="invoice-container" style="width: 50%">
      <!-- INVOICE METADATA -->
      <table style="width: 100%" class="border-collapse">
        <tr>
          <td class="p-2">
            <h6>Sayın,</h6>
          </td>
        </tr>
      </table>

      <br />
      <table
        style="
          width: 100%;
          border-top: 1px solid grey;
          width: 100%;
          text-align: center;
        "
        class="border-collapse"
      >
        <tr>
          <td style="padding: 10px">
            <h6>
              E-posta adresinizi doğrulamanız gerekmektedir. E-posta doğrulama
              kodunuz;
            </h6>
            <p style="color: darkblue; font-size: 65px; font-weight: bold">
              {{ mailCode }}
            </p>
          </td>
          <td style="padding: 10px; text-align: right"></td>
        </tr>
      </table>
      <br />
      <table
        style="border-top: 1px solid grey; width: 100%"
        class="border-collapse"
      >
        <tr>
          <td></td>
        </tr>
        <br />
      </table>
      <br />
      <table style="width: 100%" class="border-collapse">
        <tr>
          <td class="p-2">
            <h6>Geçerli süre içinde kodu onaylayınız.</h6>
          </td>
        </tr>
      </table>

      <br />

      <!-- INVOICE FOOTER -->
    </vx-card>
  </div>
</template>
<script>
//import { defineComponent } from "@vue/composition-api";
import Store from "../../../store/store";
import state from "../../../store/state";

export default {
  props: [],
  //[ pazaryerData=[], "orderNumber", "invoiceFirstName", "invoiceLastName", "shipFullName"],

  data() {
    return {
      mailCode: "",
      mailNumberControl: "",
      mailNumber: "",
      logoUrl: "",
      company: "",
      companyAdres: "",
      invoiceValidate: true,
    };
  },

  methods: {
    getNow: function () {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const year = today.getFullYear();
      const output = day + "." + month + "." + year;

      return output;
    },

    createMailCode() {
      this.mailNumberControl = "";
      for (let i = 0; i < 6; i++) {
        this.mailNumberControl =
          Math.floor(Math.random() * 10).toString() + this.mailNumberControl;
      }
      this.mailCode = this.mailNumberControl;

      this.$store.commit("strMailCode", this.mailCode);

      //  Store.state.mailControlCode = this.mailNumberControl;
      //  console.log(Store.state.mailControlCode);
    },
  },
  computed: {},

  created() {
    this.logoUrl = Store.state.logoUrl;
    this.company = Store.state.firmaAdi;
    this.createMailCode();
  },
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  },
};
</script>
